import { Button, Dialog, DialogActions, Typography } from '@astro-ui/components'

type ConfirmationDeleteImagePropsType = {
  onClickBtnConfirm: () => void
  onClickBtnClose: () => void
}

const ConfirmationDeleteImage = ({
  onClickBtnConfirm,
  onClickBtnClose,
}: ConfirmationDeleteImagePropsType) => (
  <Dialog
    open
    title="Konfirmasi Hapus Foto"
    onClose={onClickBtnClose}
    maxWidth="sm"
    fullWidth
    DialogActionComponent={
      <DialogActions>
        <Button variant="outlined" onClick={onClickBtnClose}>
          Batalkan
        </Button>
        <Button variant="contained" onClick={onClickBtnConfirm}>
          Ya, Saya Yakin
        </Button>
      </DialogActions>
    }
  >
    <Typography>Apakah kamu yakin hapus foto ?</Typography>
  </Dialog>
)
export default ConfirmationDeleteImage
